import { render, staticRenderFns } from "./TicketWithLink.vue?vue&type=template&id=6a486b48&scoped=true&"
import script from "./TicketWithLink.vue?vue&type=script&lang=js&"
export * from "./TicketWithLink.vue?vue&type=script&lang=js&"
import style0 from "./TicketWithLink.vue?vue&type=style&index=0&id=6a486b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a486b48",
  null
  
)

export default component.exports